import styled from 'styled-components';

export const SUserListWrapper = styled.div`
  width: 100%;
`;
